import React from 'react';
import PropTypes from 'prop-types';

import { Abstrap } from '../..';

const propTypes = {
    ...Abstrap.propTypes,
    alt: PropTypes.string,
    sizeFactor: PropTypes.number,
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'img',
    src: '/images/pro/illustration/scan-list_empty.svg',
    alt: 'Aucun élément',
    sizeFactor: 1,
};

class EmptyStateImage extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-empty-state__img',
            className,
        ];
    }

    render() {
        const { alt, src, sizeFactor } = this.props;
        return (
            <this.props.componentClass
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                {...this.filterProps()}
                className={this.getClassName()}
                src={src}
                alt={alt}
                style={{
                    width: `${100 * sizeFactor}%`,
                    height: `${100 * sizeFactor}%`,
                }}
            />
        );
    }

}

EmptyStateImage.propTypes = propTypes;

EmptyStateImage.defaultProps = defaultProps;

export default EmptyStateImage;
